import { LiveAnnouncer } from '@angular/cdk/a11y';
import { EventEmitter, OnChanges, SimpleChanges, } from '@angular/core';
import { AppStateFacade } from '@app-state';
import { FeatureFlag, } from '@models';
import { TranslateService } from '@ngx-translate/core';
var UiUserProfileNotificationsComponent = /** @class */ (function () {
    function UiUserProfileNotificationsComponent(_appState, _translateService, _liveAnnouncer) {
        this._appState = _appState;
        this._translateService = _translateService;
        this._liveAnnouncer = _liveAnnouncer;
        this.controlsAccess = {};
        this.notificationRightsWarning = "indicates you don't currently have access to receive that type of notification";
        this.viewOnly = false;
        this.isLoadingMap = {};
        this.notificationChanged = new EventEmitter();
        this.keys = [];
    }
    Object.defineProperty(UiUserProfileNotificationsComponent.prototype, "hasNotificationWarning", {
        get: function () {
            var _this = this;
            return this.keys.reduce(function (current, key) {
                return current || !_this.controlsAccess[key];
            }, false);
        },
        enumerable: true,
        configurable: true
    });
    UiUserProfileNotificationsComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (!!changes.notificationSettings) {
            var keys = Object.keys(this.notificationSettings);
            var excludedKeys_1 = [];
            var keysPerFeature = new Map([
                [FeatureFlag.Tasks, 'tasks'],
            ]);
            keysPerFeature.forEach(function (key, feature) {
                if (!_this._appState.settings.isFeatureEnabled(feature)) {
                    excludedKeys_1.push(key);
                }
            });
            this.keys = keys.filter(function (key) { return !excludedKeys_1.includes(key); });
        }
    };
    UiUserProfileNotificationsComponent.prototype.onChange = function (key, change) {
        var isCheckedString = this._translateService.instant("checkbox_" + (change.checked ? 'checked' : 'unchecked'));
        this._liveAnnouncer.announce(this.notificationTranslations[key] + " " + isCheckedString);
        this.notificationChanged.emit({
            key: key,
            enabled: change.checked,
        });
    };
    return UiUserProfileNotificationsComponent;
}());
export { UiUserProfileNotificationsComponent };
